import { connect } from 'react-redux';
import OrdersIndex from './OrdersIndex';
import { mapStateToProps, mapDispatchToProps } from './OrdersIndex.state';

export default connect(mapStateToProps, mapDispatchToProps)(OrdersIndex);
